/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLetterDSmall = createReactComponent("letter-d-small", "IconLetterDSmall", [
  [
    "path",
    { d: "M10 8v8h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-2z", key: "svg-0" }
  ]
]);

export { IconLetterDSmall as default };
//# sourceMappingURL=IconLetterDSmall.js.map
